import { useRef, useState } from "react";

interface ProfileVideoProps {
  src: string;
  poster: string;
  className?: string;
}

export function ProfileVideo({ src, poster, className }: ProfileVideoProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [posterVisible, setPosterVisible] = useState(false);
  const needsScrub = useRef(false);

  function handleMouseEnter() {
    const video = videoRef.current;
    if (!video) return;

    needsScrub.current = false;
    setPosterVisible(false);
    video.currentTime = 0;
    video.play();
  }

  function coverAndReset() {
    const video = videoRef.current;
    if (!video) return;

    video.pause();
    needsScrub.current = true;
    setPosterVisible(true);
  }

  function handleTransitionEnd() {
    if (!needsScrub.current) return;

    const video = videoRef.current;
    if (!video) return;

    video.currentTime = 0;
    needsScrub.current = false;
    setPosterVisible(false);
  }

  return (
    <div
      className={`relative overflow-hidden ${className ?? ""}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={coverAndReset}
    >
      <video
        ref={videoRef}
        src={src}
        muted
        playsInline
        preload="metadata"
        onEnded={coverAndReset}
        className="h-full w-full object-cover"
      />
      <img
        src={poster}
        alt=""
        aria-hidden
        onTransitionEnd={handleTransitionEnd}
        className={`pointer-events-none absolute inset-0 h-full w-full object-cover transition-opacity duration-300 ease-out ${posterVisible ? "opacity-100" : "opacity-0"}`}
      />
    </div>
  );
}
